import { render, staticRenderFns } from "./FAQInquiry.vue?vue&type=template&id=57e5a573&scoped=true"
import script from "./FAQInquiry.vue?vue&type=script&lang=js"
export * from "./FAQInquiry.vue?vue&type=script&lang=js"
import style0 from "./FAQInquiry.vue?vue&type=style&index=0&id=57e5a573&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5a573",
  null
  
)

export default component.exports